export { default } from './CTABoxed';
